module.exports = __webpack_public_path__ + "img/youtube.f79f8091.svg";